import { IS_LOCALHOST } from 'src/config-global';
import { hasPermission } from 'src/utils/permissions';
import type { Permission, PermissionMatrixLike } from 'src/utils/permissions';

import type { AnyTool } from './tool-types';

export type PermissionVerdict =
  | { allowed: true }
  | { allowed: false; resource: string; action: Permission };

export const checkToolPermission = (
  tool: AnyTool,
  matrix: PermissionMatrixLike | null
): PermissionVerdict => {
  const { resource, action } = tool.permission;

  if (IS_LOCALHOST || hasPermission(matrix, resource, action)) {
    return { allowed: true };
  }
  return { allowed: false, resource, action };
};
